import { AdditionalInterestType } from "@covertree/new-business-graphql";

import { states } from "@covertree/consts";
import type { InsuredTabAdditionalInterest } from "@redux/slices/endorsement";

import type { AdditionalInterestFormData } from "./types";

/** Zip digits from the form - "xxxxx" or "xxxxx-xxxx" as stored on the interest. */
const formatZipCode = (zipCode: string) => {
  const digits = zipCode.replace(/\D/g, "");

  return digits.length === 9
    ? `${digits.slice(0, 5)}-${digits.slice(5)}`
    : digits;
};

/** Form-data - stored interest fields (shared by add and edit). */
const toInterestFields = (data: AdditionalInterestFormData) => ({
  name: data.name,
  type: data.type as AdditionalInterestType,
  streetAddress: data.streetAddress,
  lotUnit: data.lotUnit || null,
  city: data.city,
  state: data.state.value,
  zipCode: formatZipCode(data.zipCode),
  email: data.email || null,
  accountNumber: data.accountNumber || null,
});

/** Stored interest - form-data, for seeding the edit form. */
const toFormData = (
  interest: InsuredTabAdditionalInterest
): AdditionalInterestFormData => ({
  name: interest.name,
  type: interest.type,
  streetAddress: interest.streetAddress,
  lotUnit: interest.lotUnit ?? "",
  city: interest.city,
  state: states.find((s) => s.value === interest.state) ?? {
    label: "",
    value: "",
  },
  zipCode: interest.zipCode.replace(/\D/g, ""),
  email: interest.email ?? "",
  accountNumber: interest.accountNumber ?? "",
});

export { toInterestFields, toFormData };
